{
    "NAME": "CodeAddModify",
    "GeneralTitle": "Allgemein",
    "ScopeAssignmentTitleTitle": "Umfang Zuweisung",
    "AddUserTitle": "Code hinzufügen",
    "ModifyCodeTitle": "Code ändern",
    "GUID": "BEZEICHNER (GUID):",
    "GUIDPlaceholder": "[Auto Generated]",
    "Code": "Code:",
    "CodeType": "Code-Typ:",
    "CodeTypeHelp": "Legt fest, welcher Typ der neue Code sein wird",
    "CodeTypeOptionOne": "Konto\/Bevollmächtigung",
    "CodeTypeOptionTwo": "ACD Nicht verfügbar",
    "CodeTypePlaceholder": "Konto\/Bevollmächtigung",
    "Description": "Beschreibung:",
    "UpdateExisting": "Doppelte Einträge aktualisieren:",
    "TelServer": "Telefonie-Server",
    "Partition": "Trennwand",
    "CodeAddModify_AccountAuthorisation": "Konto\/Bevollmächtigung",
    "CodeAddModify_ACDNotAvailable": "ACD Nicht verfügbar",
    "CodeAddModify_ErrorMessage_Server_Error": "Server-Fehler",
    "CodeAddModify_ErrorMessage_Successful": "Erfolg",
    "CodeAddModify_ServerErrorTitle": "Validierungsfehler",
    "CodeAddModify_ValidationWarning": "Bitte stellen Sie sicher, dass alle Felder korrekt ausgefüllt sind",
    "CodeAddModify_ButtonHelpLabel": "Hilfe?",
    "CodeAddModify_ButtonSubmitLabel": "Speichern Sie",
    "CodeAddModify_ButtonCancelLabel": "Abbrechen",
    "CodeAddModify_PromptMessage": "Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
    "CodeAddModify_PromptConfirm": "Ja",
    "CodeAddModify_PromptCancel": "Abbrechen",
    "CodeAddModify_DetailsTitle": "Benutzer-Details",
    "CodeAddModify_ValidationError": "Validierungsfehler",
    "Errors_Code_Required": "Dieses Feld ist erforderlich",
    "Errors_Code_Validation": "Gültiges Format erforderlich: 1, 3-5",
    "Errors_CodeAddModify_Code_Length": "Der Codename muss weniger als 100 Zeichen umfassen.",
    "Errors_CodeAddModify_Description_Length": "Die Beschreibung muss weniger als 100 Zeichen umfassen"
}